// utils/adgroupFieldConstants.js

/**
 * 广告组可选择的字段列表
 */
export const ADGROUP_FIELDS = [
    { key: 'adgroup_id', label: '广告组ID', default: true },
    { key: 'adgroup_name', label: '广告组名称', default: true },
    { key: 'campaign_name', label: '所属系列', default: true },
    { key: 'optimization_goal', label: '优化目标', default: true },
    { key: 'budget', label: '预算', default: true },
    { key: 'bid_type', label: '出价方式', default: true },
    { key: 'conversion_bid_price', label: '目标出价', default: false },
    { key: 'promotion_type', label: '推广类型', default: true },
    { key: 'placements', label: '投放位置', default: true },
    { key: 'operation_status', label: '状态', default: true },
    { key: 'schedule_start_time', label: '开始时间', default: false },
    { key: 'schedule_end_time', label: '结束时间', default: false },
    { key: 'create_time', label: '创建时间', default: true },
    { key: 'modify_time', label: '修改时间', default: false },
    { key: 'targeting_summary', label: '定向摘要', default: false }
]

/**
 * 字段显示名称映射
 */
export const ADGROUP_FIELD_LABEL = {
    adgroup_id: '广告组ID',
    adgroup_name: '广告组名称',
    campaign_name: '所属系列',
    optimization_goal: '优化目标',
    budget: '预算',
    bid_type: '出价方式',
    conversion_bid_price: '目标出价',
    promotion_type: '推广类型',
    placements: '投放位置',
    operation_status: '状态',
    schedule_start_time: '开始时间',
    schedule_end_time: '结束时间',
    create_time: '创建时间',
    modify_time: '修改时间',
    targeting_summary: '定向摘要'
}